module.exports = __webpack_public_path__ + "static/media/LanternCityMarketEXTA0005_design_clean_v001.c9f5a2be.png";